var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full max-w-screen-xl relative mx-auto py-8 rounded-lg relative"},[(_vm.$usesFeature('candidate-wizard'))?_c('EditJobFormSteps'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }